import { useSelector } from 'react-redux';
import FirmNavnId from '../../../models/FirmNavnId';
import TTReportItem from '../../../models/payload/TTReportItem';
import { TaleSearchParams } from '../../../models/TalenesTale';
import { AppState } from '../../../store/rootReducer';
import SalgsstatistikkTable from './SalgsstatistikkTable';

type TallenesTaleState = AppState['tallenesTale'];

interface VisningConfig {
  /** Column label of the id; undefined = no id column. */
  idLabel?: string;
  nameLabel: string;
  title: string;
  /** Where the report and its search params are in the store. */
  rows: (s: TallenesTaleState, visning: string) => TTReportItem[] | undefined;
  search: (s: TallenesTaleState, visning: string) => TaleSearchParams | undefined;
  /** The selected sub-store customer (from the Kunde visning) is added to the title. */
  subKunde?: boolean;
}

const other = { rows: (s: TallenesTaleState, v: string) => s.salesReportOther[v], search: (s: TallenesTaleState, v: string) => s.taleSearchOther[v] };

// Every visning but Kunde (which has its own component: clicking a customer selects it).
const VISNING_CONFIG: { [visning: string]: VisningConfig } = {
  Varegruppe: { idLabel: 'Varegruppe ID', nameLabel: 'Varegruppe navn', title: 'Salgsstatistikk etter varegruppe', subKunde: true, rows: (s) => s.salesReportVGruppe, search: (s) => s.taleSearchVGruppe },
  Hovedgruppe: { nameLabel: 'Hovedgruppe', title: 'Salgsstatistikk etter hovedgruppe', subKunde: true, rows: (s) => s.salesReportHGruppe, search: (s) => s.taleSearchHGruppe },
  Gruppe: { nameLabel: 'Gruppe', title: 'Salgsstatistikk etter gruppe', subKunde: true, rows: (s) => s.salesReportGruppe, search: (s) => s.taleSearchGruppe },
  Summeringsgruppe: { nameLabel: 'Summeringsgruppe', title: 'Salgsstatistikk etter summeringsgruppe', subKunde: true, rows: (s) => s.salesReportSGruppe, search: (s) => s.taleSearchSGruppe },
  Totalsalg: { nameLabel: 'Butikk', title: 'Totalsalg', ...other },
  Kundekategori: { idLabel: 'Kategori', nameLabel: 'Kundekategori', title: 'Salgsstatistikk etter kundekategori', ...other },
  Handelsdistrikt: { idLabel: 'Distrikt', nameLabel: 'Handelsdistrikt', title: 'Salgsstatistikk etter handelsdistrikt', ...other },
  Ordremottaker: { idLabel: 'Kode', nameLabel: 'Ordremottaker', title: 'Salgsstatistikk etter ordremottaker', ...other },
  Selger: { idLabel: 'Selgernr', nameLabel: 'Selger', title: 'Salgsstatistikk etter selger', ...other },
};

/** The visninger this component handles. */
export const OTHER_VISNINGER = Object.keys(VISNING_CONFIG);

const TallenesTaleListOther = ({ visning }: { visning: string }) => {
  const config = VISNING_CONFIG[visning];
  const salesReport = useSelector((state) => config?.rows((state as AppState).tallenesTale, visning));
  const taleSearch = useSelector((state) => config?.search((state as AppState).tallenesTale, visning));
  const selectedSubKunde: FirmNavnId = useSelector((state) => (state as AppState).tallenesTale.selectedSubKunde);
  if (!config) return null;

  const subKunde = config.subKunde && selectedSubKunde?.firmID > 0 ? ', ' + selectedSubKunde.firmName : '';
  return (
    <SalgsstatistikkTable visning={visning} rows={salesReport ?? []} taleSearch={taleSearch}
      idLabel={config.idLabel} nameLabel={config.nameLabel}
      title={taleSearch ? config.title + ', ' + taleSearch.butikk + subKunde : null} />
  );
};

export default TallenesTaleListOther;
